module.exports = __webpack_public_path__ + "img/mammut-tablet_0a2b2c30134b032d85a9964eefd815ce.jpg";


//////////////////
// WEBPACK FOOTER
// ./client/img/mammut-tablet.jpg
// module id = 283
// module chunks = 0